<template>
  <div class="Message xi">
    <nh-com></nh-com>
    <div class="personal-content">
      <div class="personal-box clearfix">
        <div class="personal-left">
          <hd-img :active="2"></hd-img>
        </div>
        <div class="personal-right">
          <div class="top1">
            <div class="flex-start">
              <span style="margin-right: 5px; font-size: 16px;cursor: pointer;" @click="goBack"><i class="el-icon-arrow-left"></i>返回</span>
              <div class="line-title"></div>
              <p style="margin-right: 10px; font-size: 16px">收益明细统计</p>
              <img class="pointer" v-if="isShow" src="../../assets/img/userInfo/preview_open.png" @click="isShow = false" />
              <img class="pointer" v-if="!isShow" src="../../assets/img/userInfo/preview_close.png" @click="isShow = true" />
            </div>
            <div class="flex-space-around">
              <div class="top1-2 flex-center-columns">
                <div v-if="isShow">
                  <span class="num">{{ UserBalance.commanderAssetsTotalBalance>0?UserBalance.commanderAssetsTotalBalance.toFixed(2):'0' }}</span>
                </div>
                <div v-else>
                  <span class="num">******</span>
                </div>
                <div>当前可分金额(元)</div>
              </div>

              <div class="btn1" style="margin-left: 20px;"  @click="goNext">一键分账</div>
              <div class="line-1"></div>
              <div class="top1-3 flex-center-columns">
                <div v-if="isShow">
                  <span class="num">{{ UserBalance.cumulativeIncome>0?UserBalance.cumulativeIncome.toFixed(2):'0' }}</span>
                </div>
                <div v-else>
                  <span class="num">******</span>
                </div>
                <div>累计收益(元)</div>
              </div>
              <div class="top1-3 flex-center-columns">
                <div v-if="isShow">
                  <span class="num">{{ UserBalance.totalExpenditure>0?UserBalance.totalExpenditure.toFixed(2):'0' }}</span>
                </div>
                <div v-else>
                  <span class="num">******</span>
                </div>
                <div>已分金额(元)</div>
              </div>
            </div>
          </div>
          <p style="font-size: 16px; margin: 10px 0">明细列表</p>
          <div class="top2">
            <div class="recordtitle">
              <!-- <el-date-picker v-model="valueDate" type="month" placeholder="选择月" value-format="yyyy-MM" @change="valueDatechange"> </el-date-picker> -->
              <!-- <el-select v-model="state" placeholder="请选择" size="small" style="margin-right: 10px">
              <el-option v-for="item in statusOption" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select> -->
              <div class=" flex-start"> 
                <el-date-picker v-model="valueDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions0" size="small" style="margin-right: 10px" @change="valueDatechange"> </el-date-picker>
                <div class=" flex-start" style="margin-left: 10px;"> 
                  <div>支出：{{ expenseAmount>0?expenseAmount.toFixed(2):'--' }}</div>
                  <div style="margin-left: 10px;">收入：{{ incomeAmount>0?incomeAmount.toFixed(2):'--' }}</div>
                </div>
              </div>
              <div class="" style="display: flex">
                <div :class="type == 0 ? 'boxtagCheck' : 'boxtag'" @click="slecttype(0)">全部</div>
                <div :class="type == 1 ? 'boxtagCheck' : 'boxtag'" @click="slecttype(1)" style="margin-left: 10px">支出</div>
                <div :class="type == 2 ? 'boxtagCheck' : 'boxtag'" @click="slecttype(2)" style="margin-left: 10px">收入</div>
                <!-- <div :class="type == 3 ? 'boxtagCheck' : 'boxtag'" @click="slecttype(3)" style="margin-left: 10px">待入账</div> -->
              </div>
            </div>
            <div class="center-content">
              <el-table :data="UserBalanceTable" border :header-cell-style="{ background: '#F5F5F5' }">
                <el-table-column prop="addressee" label="时间" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.createTime | timefilters }}
                  </template>
                </el-table-column>
                <el-table-column prop="purpose" label="操作" align="center">
                  <template slot-scope="scope">
                    <!-- 支出 -->
                    <el-tag size="small" v-if="scope.row.purpose == 'withdrawal'">提现</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'refund'">退款</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'buyMember'">购买会员</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'upgradeMember'">升级会员</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'renewalUpgrade'">续费升级订单</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'renewalMember'">续费会员</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'payVideo'">购买视频</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'teamPerformanceIncome'">团队绩效发放</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'MZRefund'">门诊退款</el-tag>
                    <!-- 收入 -->
                    <el-tag size="small" v-if="scope.row.purpose == 'teamPerformanceDistribution'">团队绩效发放</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'recharge'">充值</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'BalanceTransfers'">余额转账</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'entryGoods'">商品入账</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'distribution'">分销获利</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'shareMoney'">分享获利</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'shareMoneySecond'">分享获利抽佣</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'publicShare'">公益分红</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'purchaseGoods'">购买商品</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'refundChargebackMoney'">退款手续费</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'saleVideo'">出售视频</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'MZPayment'">门诊付款</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'MZAudit'">门诊审方</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'MZDistribution'">门诊抽佣</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'AppointmentOrder'">预约支出</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'AppointmentOrderPayment'">预约付款</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'AppointmentRefund'">预约退款</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'PlatformAppointmentOrderCommission'">预约抽佣</el-tag>
                    <el-tag size="small" v-if="scope.row.purpose == 'distributionExpenditure'">返利支出</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="amount" label="余额(元)" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.type == 2 && scope.row.state == 1" style="color: #00a08c; font-weight: bold">{{ "+ " + scope.row.amount }}</div>
                    <div v-if="scope.row.type == 1 && scope.row.state == 1" style="color: #e52626; font-weight: bold">{{ "- " + scope.row.amount }}</div>
                    <div v-if="scope.row.state == -1 || scope.row.state == -2 || scope.row.state == 0 || scope.row.state == -3" style="color: #e98813; font-weight: bold">{{ scope.row.amount }}</div>
                  </template>
                </el-table-column>
              </el-table>
              <div class="pageBox">
                <el-pagination background layout="total,prev, pager, next" @current-change="AuditCurrentChange" :page-size="15" :current-page.sync="AuditcurrentPage" :total="auditTotal"> </el-pagination>
              </div>
            </div>
          </div>
          <!--    详情    -->
        </div>
      </div>
    </div>
    <ft-com></ft-com>
  </div>
</template>

<script>
import { shoppingMall } from "../../components/shoppingMall/shoppingMall";
// import { shoppingMall } from '../../components/shoppingMall/shoppingMall';
import ftCom from "../../components/footer";
import nhCom from "../../components/navheader";
import hdImg from "../../components/headerImg";
import { UserInfo } from "../../components/User/UserInfo";
var pageIndex = 1;
var keywordVal = "";
var myDate = new Date();
export default {
  name: "Message",
  components: {
    ftCom,
    nhCom,
    hdImg,
  },
  data() {
    var shoppingMalltem = new shoppingMall(this.TokenClient, this.Services.shoppingMall);
    var UserDistributorltem = new shoppingMall(this.TokenClient, this.Services.Authorization);
    var UserDistributorltemdrug = new shoppingMall(this.TokenClient, this.Services.Drug);
    var user = new UserInfo(this.TokenClient, this.Services.Authorization);

    return {
      userDomain: user,
      UserBalance: {
        assetsBalance: 0,
      },
      labelPosition: "right",
      MessageList: [],
      MessageDetail: {},
      total: 0,
      currentPage: 1, //初始页
      keyword: "",
      PageTotal: 1,
      MessageTotal: 0,
      rloading: [], //loading遮罩
      shoppingMallMain: shoppingMalltem,
      UserDistributorMain: UserDistributorltem,
      UserDistributorMaindrug: UserDistributorltemdrug,
      Image: {
        //单击图片上传控件中的图片时，放大显示
        dialogVisible: false,
        dialogImageUrl: "",
      },
      dialogVisible: false,
      RegionData: [],
      UserBalanceTable: [],
      today: myDate.getFullYear(),
      month: myDate.getMonth() + 1,
      type: "0",
      pageIndex: 1,
      valueDate: "",
      auditTotal: 0,
      AuditcurrentPage: 0,
      appdialogVisible: false,
      chargedialogVisible: false,
      url1: require("@/assets/img/interrogation/xiaoimg.png"),
      url2: require("@/assets/img/interrogation/APPimg.png"),
      ruleForm: {
        money: "",
        radio: "1",
      },
      userInfo: this.$store.state.localData.userInfo,
      weChatInfo: "",
      qRcodeUrl: "",
      timer: null,
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      statusOption: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "2",
          label: "余额",
        },
        {
          value: "1",
          label: "微信",
        },
      ],
      startTime: "",
      endTime: "",
      myprice: 0,
      isShow: false,
      userAccountInfo : {
        expenseAmount: 0,
        incomeAmount: 0,
        pendingAmount: 0,
      },
      expenseAmount:0,
      incomeAmount:0

    };
  },
  mounted() {
    this.AllMessages();
    this.zero();
  },
  methods: {
       goNext(){
        if (this.UserBalance.commanderTeamCount == 0) {
          this.$message({
            message: '团队人数大于0才可分账',
            type: 'warning'
          })
          return
        }
        this.$router.push('/personal/teamShareBonus')
       },
    AuditCurrentChange(pageNum) {
      this.AuditcurrentPage = pageNum;
      this.pageIndex = pageNum;
      this.getAssetsDetailsListime();
      this.getUserBillingSummaryByDate()
    },
    slecttype(e) {
      this.MessageDetail = [];
      this.pageIndex = 1;
      this.AuditcurrentPage = 0;
      if (e == 0) {
        this.type = 0;
        this.getAssetsDetailsListime();
        this.getUserBillingSummaryByDate()
      } else if (e == 1) {
        this.type = 1;
        this.getAssetsDetailsListime();
        this.getUserBillingSummaryByDate()
      } else if (e == 2) {
        this.type = 2;
        this.getAssetsDetailsListime();
        this.getUserBillingSummaryByDate()
      } else {
        this.type = 3;
        this.getAssetsDetailsListime();
        this.getUserBillingSummaryByDate()
      }
    },
    gorecord(item) {
      var _this = this;
      _this.dialogVisible = true;
      _this.ruleForm = item;
    },
    valueDatechange(e) {
      this.startTime = "";
      this.endTime = "";
      if (this.valueDate) {
        this.startTime = this.valueDate[0] + " 00:00:00";
        this.endTime = this.valueDate[1] + " 23:59:59";
      }
      this.userAccountInfo = {
        expenseAmount: 0,
        incomeAmount: 0,
        pendingAmount: 0,
      };
      this.getAssetsDetailsListime();
      this.getUserBillingSummaryByDate();
    },
    getUserBillingSummaryByDate() {
      var _this = this;
      _this.UserDistributorMain.GetUserBillingSummaryByDate(
        _this.startTime,
        _this.endTime,
        function (data) {
          _this.userAccountInfo = data.data;
        },
        function (err) {
          _this.UserBalanceTable = [];
          console.log(err);
        }
      );
    },
    //返回列表页
    goBack(){
      this.$router.go(-1)
    },
    //分页点击事件
    handleCurrentChange: function (pageNum) {
      this.currentPage = pageNum;
      pageIndex = pageNum;
      this.getAssetsDetailsListime();
      this.getUserBillingSummaryByDate()
    },
    AllMessages() {
      var _this = this;
      _this.UserDistributorMain.getCommanderAssetsDetails(
        function (data) {
          _this.UserBalance = data.data;
        },
        function (err) {
          _this.UserBalance = [];
          console.log(err);
        }
      );
    },
    zero() {
      if (parseInt(this.month) < 10) {
        this.month = "0" + this.month;
      }
      this.valueDate = this.today + "-" + this.month;
      this.getAssetsDetailsListime();
      this.getUserBillingSummaryByDate()
    },
    getAssetsDetailsListime() {
      var _this = this;
      _this.UserDistributorMain.GetCommanderAssetsDetails(
        _this.startTime,
        _this.endTime,
        _this.type.toString(),
        _this.pageIndex,
        "15",
        function (data) {
          _this.expenseAmount = 0
          _this.incomeAmount = 0
						for (var i=0; i<data.data.results.length; i++) {
							let item=data.data.results[i]
							if(item.type==1){
								_this.expenseAmount+=item.amount
							}
							if(item.type==2){
								_this.incomeAmount+=item.amount
							}
						}
          _this.UserBalanceTable = data.data.results;
          _this.auditTotal = data.data.dataTotal;
        },
        function (err) {
          _this.UserBalanceTable = [];
          console.log(err);
        }
      );
    },
    // getAssetsDetailsList() {
    //   var _this = this;
    //   let todate = _this.today + "-" + _this.month;
    //   _this.UserDistributorMain.GetCommanderAssetsDetails(
    //     _this.startTime,
    //     _this.endTime,
    //     _this.type.toString(),
    //     _this.pageIndex,
    //     "10",
    //     function (data) {
    //       _this.UserBalanceTable = data.data.results;
    //       _this.auditTotal = data.data.dataTotal;
    //     },
    //     function (err) {
    //       _this.UserBalanceTable = [];
    //       console.log(err);
    //     }
    //   );
    // },
  },
};
</script>

<style scoped>
@import "../../assets/css/footer.css";

#page {
  text-align: center;
  padding: 100px 0 30px;
}
.imgBox {
  display: flex;
  justify-content: space-between;
  margin: 0 60px;
}
.imgBoxurl {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.imgBoxurl1 {
  width: 180px;
  height: 180px;
}
.pageBox {
  text-align: center;
  margin-top: 5px;
}
.top2 {
  padding: 25px 30px;
  background: #fff;
}
.recordtitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
}
.boxtagCheck {
  padding: 0 20px;
  background: linear-gradient(90deg, #ff793b, #ff9d70);
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.pointer{
  cursor: pointer;
}
.boxtag {
  cursor: pointer;
  padding: 0 20px;
  background-color: #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
}
.banner {
  width: 100%;
  height: 160px;
  background: url("../../assets/img/news_banner.jpg") center no-repeat;
}

.banner-wrap {
  position: relative;
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

.banner-text {
  float: left;
}

.banner-text h3 {
  padding-top: 35px;
  font-size: 26px;
  font-weight: normal;
  color: #ffffff;
}

.banner-text p {
  font-size: 14px;
  color: #ffffff;
  margin-top: 20px;
}
.centercontentMoney {
  margin: 20px;
  background: #f5f5f5;
  padding: 20px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.centercontentMoney1 {
  width: calc(100% - 300px);
  display: flex;
  justify-content: space-around;
  align-items: baseline;
}
.centercontentMoney2 {
  width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.centercontentMoney1i {
  font-size: 42px;
}
.centercontentMoney1Money {
  font-size: 48px;
  color: #00afb5;
}
.center-content {
  margin: 10px 0;
}
.banner-text p a {
  color: #ffffff;
  font-size: 14px;
  margin: 0 5px;
}

/**/
.personal-content {
  background: #f7f7f7;
  padding: 40px 0;
}

.personal-box {
  width: 1200px;
  margin: 0 auto;
}

.personal-left {
  float: left;
}

.personal-right {
  float: right;
  width: 985px;
  min-height: 740px;
  /* background: #ffffff; */
  box-sizing: border-box;
}

.personal-right-tit {
  border-bottom: 1px solid #e5e5e5;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.personal-right-tit .iconfont {
  color: #04a290;
  font-size: 24px;
  margin-right: 5px;
}

.personal-right-tit span {
  display: inline-block;
  font-size: 24px;
  font-weight: 700;
  color: #333333;
}

.personal-right-tit span em {
  font-style: normal;
  color: #04a290;
}

.personal-right-tit .el-icon-delete {
  float: right;
  font-size: 18px;
}

.msg-list {
  padding: 0 20px;
}

.msg-list .msg-item {
  padding: 8px 0;
  border-bottom: 1px dashed #e5e5e5;
  line-height: 40px;
  height: 40px;
}

.msg-list .msg-item h4 {
  color: #999999;
  font-weight: normal;
  width: 700px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.msg-list .msg-item.noread h4 {
  color: #333333;
}

.msg-list .msg-item p {
  color: #999999;
}

.msg-detail {
  padding: 20px;
  display: none;
}

.msg-detail .mess-tit {
  text-align: center;
}

.msg-detail .mess-info p {
  text-indent: 28px;
}
.mess-info .item-img {
  margin-right: 10px;
  display: flex;
  justify-content: flex-start;
  justify-items: center;
  flex-wrap: wrap;
}
.item-img img {
  width: 118px;
  height: 118px;
}
</style>
<style scoped lang="scss">
.top1 {
  padding: 20px 15px;
  color: #000;
  background: #ffffff;
  border-radius: 8px;
  .line-1 {
    width: 1px;
    height: 70px;
    background: #b9b9b9;
  }
  .right-t {
    margin-left: 10px;
  }
  .top1-1-1 {
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    margin-right: 10px;
  }
  .top1-1-2 {
    background: #ffffff;
    border-radius: 10px;
    border: 1px solid #b5d5d0;
    padding: 0 10px;
  }
  .top1-1-3 {
    color: #333;
  }
  .num {
    font-size: 25px;
    font-weight: bold;
  }
  .t-desc {
    font-size: 14px;
    font-weight: bold;
  }
  .btn1 {
    background: linear-gradient(90deg, #ff793b, #ff9d70);
    border-radius: 4px;
    color: #fff;
    padding: 0 20px;
    cursor: pointer;
  }
  .btn2 {
    background: linear-gradient(90deg, #ff9c27, #ffc36f);
    border-radius: 4px;
    color: #fff;
    padding: 0 20px;
    cursor: pointer;
  }
  .btn3 {
    background: linear-gradient(90deg, #00c4ac, #5bd2c3);
    border-radius: 4px;
    color: #fff;
    padding: 0 20px;
    cursor: pointer;
  }
  .total {
    font-size: 14px;
    color: #ff405e;
  }
}
.line-title {
  width: 2px;
  height: 16px;
  background: #333;
  margin-right: 5px;
  cursor: pointer;
}
</style>
